@layer overridable {
    .root video:not(:has(source)) {
        // assumption that covers the most common video aspect ratio in
        // situations where the video hasn't loaded yet
        aspect-ratio: 16 / 9;
    }
}

.root {
    position: relative;
    width: 100%;
    height: 100%;

    video {
        display: block;

        &:not(:has(source)) {
            // so you can see the spinner
            background-color: var(--black);
        }
    }
}

.button {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    border: none;
    cursor: pointer;
    z-index: 10;

    button {
        background-color: rgb(var(--black-base) / 50%);
        transition: background-color 0.3s;

        &:hover {
            background-color: rgb(var(--black-base) / 65%);
        }
    }
}

.backgroundPlayControl {
    composes: button;
    bottom: var(--spacer-24);
    gap: var(--spacer-8);
    right: var(--spacer-24);

    button {
        width: var(--spacer-32);
        height: var(--spacer-32);
    }

    .icon {
        height: var(--spacer-32);
        width: var(--spacer-32);
        fill: var(--white);
    }
}

.foregroundPlayControl {
    // Not sure I need this at all so this line hides it for now.
    // If it comes back, we'll need to make it not clash with native UI.
    display: none;
    composes: button;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
    width: var(--spacer-64);
    height: var(--spacer-64);

    &.playing {
        display: none;
    }

    .icon {
        height: 48px;
        width: 48px;
        fill: var(--white);
    }
}

.loaderOverlay {
    position: absolute;
    inset: 0;
    background-color: rgb(var(--white-base) / 30%);
    backdrop-filter: blur(3px);
    transition: opacity 0.2s;
    z-index: 1;
}

.loaderContainer {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    z-index: 2;

    svg {
        min-width: 66px;
        width: 10%;
        height: auto;
    }
}
